import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { HireDevelopers } from './pages/HireDevelopers';
import { ApplicationDevelopment } from './pages/ApplicationDevelopment';
import { WebDevelopment } from './pages/WebDevelopment';
import { MobileAppDevelopment } from './pages/MobileAppDevelopment';
import { AiMlDevelopment } from './pages/AiMlDevelopment';
import { DedicatedTeam } from './pages/DedicatedTeam';
import { Industries } from './pages/Industries';
import { CaseStudies } from './pages/CaseStudies';
import { Contact } from './pages/Contact';
import { AdminLogin } from './pages/admin/Login';
import { AdminLayout } from './components/admin/AdminLayout';
import { Dashboard } from './pages/admin/Dashboard';
import { LeadsList } from './pages/admin/LeadsList';
import { BlogList } from './pages/admin/BlogList';
import { BlogEditor } from './pages/admin/BlogEditor';

const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX';
ReactGA.initialize(GA_MEASUREMENT_ID);

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
  }, [location]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <AnalyticsTracker />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/application-development" element={<ApplicationDevelopment />} />
        <Route path="/web-development" element={<WebDevelopment />} />
        <Route path="/mobile-app-development" element={<MobileAppDevelopment />} />
        <Route path="/ai-ml-development" element={<AiMlDevelopment />} />
        <Route path="/hire-developers" element={<HireDevelopers />} />
        <Route path="/dedicated-team" element={<DedicatedTeam />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="leads" element={<LeadsList />} />
          <Route path="blog" element={<BlogList />} />
          <Route path="blog/new" element={<BlogEditor />} />
          <Route path="blog/edit/:id" element={<BlogEditor />} />
        </Route>
      </Routes>

      <Footer />
    </HelmetProvider>
  );
}
export default App;